import * as React from 'react';

import { Button } from '@cian/ui-kit';

import { FooterAction } from '../../components/FooterAction';
import { useOpenPreview } from '../../utils/sendReport';
import { useIsDesktop } from '@cian/valuation-utils-component';

export const CreateReportContainer: React.FC = () => {
  const isDesktop = useIsDesktop();

  const onSubmit = useOpenPreview();

  return (
    <FooterAction
      title="Отправьте отчёт от своего имени"
      subTitle="Уточните параметры квартиры и список аналогов"
      action={
        <Button theme="fill_primary" size="M" onClick={onSubmit} fullWidth={!isDesktop}>
          Далее
        </Button>
      }
    />
  );
};

CreateReportContainer.displayName = 'CreateReportContainer';
